import React , {Children}from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import './slide-open.scss'

const SlideOpen = (props) => {
  let orDefault = props.duration || 500;
  let { duration, children, ...others } = props
  return <CSSTransition
    timeout={orDefault}
    classNames="slide-open"
    style={{transition: `all ${orDefault}ms linear`}}
    unmountOnExit
    {...props}
  >{children}</CSSTransition>

}

let {timeout, ...transitionPropTypes} = CSSTransition.propTypes
SlideOpen.propTypes = {
  duration: PropTypes.number,
  ...transitionPropTypes
}
export default SlideOpen
